import { Component, OnInit, ViewChild, Input } from '@angular/core';

import { Router, ActivatedRoute, Params } from '@angular/router';

import { PIDService } from '../../services/pid.service';
import { NotificationService } from '../../services/notification.service';
import { UserService } from '../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';
//import { PIDTransferComponent } from '../shared/pid-transfer.component';
import { PidTableService } from '../../services/pidtable.service';

import * as _ from 'lodash';

export interface SearchParams {
  owner: string;
  status: string;
}

@Component({
  selector: 'nestas-pid-table',
  templateUrl: './pid-table.component.html',
  styleUrls: ['./pid-table.component.scss']
})
export class PIDTableComponent implements OnInit {

  @Input() pid;
  @Input() parentPID;
  @Input() pids;
  @Input() editable: Boolean;

  @Input() events: Observable<void>;

  @ViewChild('modalCopyPID') modalCopyPID;
  @ViewChild('modalEditPID') modalEditPID;

  @Input() reloadHome;// = new EventEmitter<string>();

  searchParams: Observable<Params> = this._route.queryParams;

  results = this.searchParams.pipe(
    switchMap(params => this.findProducts(params))
  );

  fileToUpload = null;
  rooms = [];
  transferEmail = null;
  transferType: "readonly";
  types: string[];
  steps = [];
  showActions = false;
  modal = {
    editPID: false,
    deletePID: false,
    newPID: false,
    transferPID: false,
    pid: null
  };
  showAll = false;
  tableCount = 0;

  allStatusTypes = [];
  allPIDOwnerTypes = [];

  allfiles = {};
  filters = {
    'type': [],
    'status': ['open', 'shared', 'ready'],
    'owner': [],
  };

  statusmap = {
    'shared': 'gedeeld',
    'transferred': 'overgedragen',
    'ready': 'download',
    'late': 'late',
    'open': 'open',
    'template': 'sjabloon',
    'pending': 'pending'
  }

  pidtypemap = {
    'flat': 'flat',
    'house': 'home',
    'kantoor': 'kantoor',
    'industrie': 'industrie',
    'appartementsgebouw': 'flat',
    'office': 'kantoor',
    'building': 'flat'
  }

  allStatusCount = {
    'open': 0,
    'transferred': 0,
    'ready': 0,
    'notsent': 0,
    'pending': 0,
    'late': 0,
    'shared': 0,
    'template': 0
  };

  isPhone = false;
  isPad = false;

  printTransferPDFrequested = false;
  putToken = null;
  putUrl = null;
  transferPDFSpec = {};

  private eventsSubscription: any;

  constructor(private _pidService: PIDService, private _notification: NotificationService,
    private _user: UserService, private _router: Router, public translate: TranslateService,
    private _pidtable: PidTableService, private _route: ActivatedRoute) {
  }

  addRoom() {
    this.rooms.push({ room: '' });
  }

  findProducts(params) {
    //console.log("find products", params);
    return [];
  }

  private _initRoomsWrapper() {
    this.rooms = _.map(this.pid.rooms, r => {
      return ({ room: r });
    });
  }

  type2imgfn = (rtype) => this._pidtable.type2imgfn(rtype);
  transferInfo = pid => this._pidtable.transferInfo(pid);
  sharedInfo = pid => this._pidtable.sharedInfo(pid, this._user.me());


  updateFilter(event) {
    const id = event.target.id || event.target.parentElement.id;

    const val = id.split('_')[3];
    const name = id.split('_')[2];
    const checked = !(this.filters[name].includes(val));
    //console.log("val", id, val, "event", event, "checked", checked, name, this.filters[name]);

    if (checked) {
      this.filters[name].push(val);
    } else {
      const index = this.filters[name].indexOf(val);
      if (index !== -1) {
        this.filters[name].splice(index, 1);
      }
    }
    //console.log("filters now", name, this.filters, this._router);

    this._router.navigate(['.'], {
      relativeTo: this._route,
      queryParams: { status: this.filters['status'], owner: this.filters['owner'] },
      queryParamsHandling: 'merge'
    });

    this.showAll = false;
    this.doUpdateFilter();

    /*console.log("force refresh");
    window.scrollTo(0, 0);*/
  }

  ownerSelected(owner) {
    return this.filters['owner'].includes(owner.id) ? "selected" : "";
  }

  doUpdateFilter = (key = 'display') => {
    // filter our data
    var parent = this;

    const temp = this.pids[key].filter(function (d) {

      if (!d['status']) {
        d['status'] = parent.getStatus(d);
      }
      
      let left = (!parent.filters['owner'].length || (d.PIDOwner && parent.filters['owner'].indexOf(d.PIDOwner._id) > -1));
      let right = (!parent.filters['status'].length || (parent.filters['status'].indexOf(d['status']) > -1));
      //console.log("status", d, d['status'], left, right);
      return left && right && (parent.parentPID || !d.parentPID || parent.sharedWithMe(d));
    });

    // update the rows
    //console.log("doUpdateFilter", key, this.pids[key], this.parentPID, temp);
    this.tableCount = temp.length;
    if (!this.showAll) {
      this.pids['filtered'] = temp.slice(0, 100);
    } else {
      this.pids['filtered'] = temp;
    }
    //console.log("doUpdateFilter done", this.pids.filtered.length);

  }

  showAllToggle() {
    //console.log("show all toggle", this.showAll, this.tableCount);
    this.doUpdateFilter();
  }

  PIDOwnerName = (pidowner) => {
    return pidowner['firstname'] ? pidowner['firstname'] + ' ' + pidowner['lastname'] : pidowner['name'];
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }

  getWidth(x) {
    if (x == 'completion') {
      if (this.isPad) {
        return 65;
      }
      return 155;
    } else {
      if (this.isPad) {
        return 45;
      }
      return 65;
    }
  }

  updateAllStatusCount() {
    var knownPIDOwners = [];
    var parent = this;
    this.allStatusCount = {
      'open': 0,
      'transferred': 0,
      'ready': 0,
      'notsent': 0,
      'pending': 0,
      'late': 0,
      'shared': 0,
      'template': 0
    };

    this.pids['all'].forEach((item: any) => {
      //console.log("get status 1", parent);

      if (!parent.parentPID && item.parentPID && !this.sharedWithMe(item)) return; // skip child PIDs in parent

      let status = this.getStatus(item);
      //console.log("get status 2", item, status);

      item['status'] = status;

      this.allStatusCount[status] += 1;

      if (item.PIDOwner && knownPIDOwners.indexOf(item.PIDOwner._id) == -1) {
        knownPIDOwners.push(item.PIDOwner._id);
        this.allPIDOwnerTypes.push({ id: item.PIDOwner._id, name: this.PIDOwnerName(item.PIDOwner) });
      }

    });
  }

  ngOnInit() {
    this.isPhone = window.matchMedia('(max-width: 767px)').matches;
    this.isPad = window.matchMedia('(max-width: 1080px)').matches;

    //console.log("phone/pad", this.isPhone, this.isPad);
    this.eventsSubscription = this.events.subscribe(() => {
      //console.log("parent event", event);
      this.doUpdateFilter();
    })

    this._pidService.getPIDTypes()
      .subscribe((response: any) => {
        this.types = response.types;
      }, error => {
        console.log(error);
      });

    //this._initRoomsWrapper();
    //console.log("nginit pid-table pids", this.pids);
    this.transferType = 'readonly';

    if (!this.parentPID) {
      this.filters['owner'].push(this._user.me()['_id']);
    }

    this.allStatusTypes = ['open', 'shared', 'ready', 'pending', 'transferred'/*, 'template'*/];


    //console.log(knownPIDOwners);
    this.updateAllStatusCount();

    this._route.queryParams.subscribe(params => {
      //console.log("pid table on init params", params);

      ['status', 'owner'].forEach(x => {
        if (params.hasOwnProperty(x)) {
          if (Array.isArray(params[x])) {
            this.filters[x] = params[x];
          } else {
            this.filters[x] = [params[x]];
          }
        }
      });

      this.doUpdateFilter();
    });
  }


  statusSelected(room, last) {
    let res = this.filters['status'].includes(room) ? "selected" : "";
    if (last) {
      res += " last";
    }
    return res;
  }

  getStatus(row) {
    let res = this._getStatus(row);
    return res;
  }

  _getStatus(row) {

    if (row.transferTo && row.transferTo.transferType) {
      if (row.transferTo.pending){
        return 'pending';
      }
      if (row.transferTo.transferType != 'shared' && row.transferTo.details.length && row.transferTo.details[0].email) {
          return 'transferred';
      }
      if (row.transferTo.transferType == 'shared' && row.sharedWith && row.sharedWith.length) {
          return 'shared';
      }
      return 'pending';
    }

    if (row.template) return 'template';

    if (row.fileTotal == row.fileCompleted) return 'ready';

    return 'open';
  }

  status2imgfn(status) {
    let stat = this.statusmap[status];
    return `../../assets/Nestas-Iconen_${stat}.png`;
  }

  private _updatePID(pid) {
    delete pid.owner;
    this.pid = _.merge(this.pid, pid);
    this._initRoomsWrapper();
    this.modal.editPID = false;
  }

  editPID() {
    this.pid.rooms = _.map(_.filter(this.rooms, r => {
      return (r.room);
    }), r => {
      return (r.room);
    });
    this._pidService.updatePID(this.pid, this._user.me()['_id']).subscribe(
      (ret: any) => {
        if (this.fileToUpload && ret.url) {
          this._pidService.uploadImg(ret.url, this.fileToUpload).subscribe(
            (success: any) => {
              this._updatePID(ret.pid);
            });
        } else {
          this._updatePID(ret.pid);
        }
      },
      err => {
        this._notification.errorServer(err);
      }
    )
  }

  removePID() {
  }

  getColor() {
    return this.pid['percentage'] > 70 ? "primary"
      : this.pid['percentage'] > 40 ? "accent"
        : "warn";
  }

  fileChangeEvent(fileInput) {
    var file = fileInput.target.files[0];
    this.fileToUpload = fileInput.target.files[0];
    this.pid.file = { type: file.type, name: file.name }
  }

  stringify(data) {
    return JSON.stringify(data);
  }

  fallbackImg($event) {
    $event.target.src = '/assets/' + this.pid.type + '.png';
  }

  details(pid) {
    if (this.editable) {
      this._router.navigate(['pid', pid._id]);
    }
  }

  displayActions() {
    if (this.editable) {
      this.showActions = true
    }
  }

  comparator(propA, propB) {
    //console.log('Sorting Comparator', propA, propB);

    // Just a simple sort function comparisoins
    if (propA.trim().toLowerCase() < propB.trim().toLowerCase()) {
      return -1;
    }
    if (propA.trim().toLowerCase() > propB.trim().toLowerCase()) {
      return 1;
    }
  }

  sharedWithMe(row) {
    let res = row && (row.sharedWith && (row.sharedWith.map(x => x._id || x).indexOf(this._user.me()['_id']) > -1) && this._user.me()['_id'] != row.PIDOwner._id);
    //console.log("sharedwith", row, res);
    return res;
  }

  allowTransfer(pid) {

    if (pid.sharedWith) {
      //console.log("shared with", pid.sharedWith._id, this._user.me()['_id']);
      if (pid.sharedWith.filter(x => (x._id || x) == this._user.me()['_id'])) {
        return false;
      }
    }

    if (!pid.children || !pid.children.length) {
      return true;
    }

    return _.every(pid.children, subPid => {
      return !subPid.copy;
    })
  }

  canEditTransferInfo(row) {
    //console.log("canEditTransferInfo", row.copy, row.transferTo);
    return (!row.copy || (row.transferTo && row.transferTo.pending)) && !this.sharedWithMe(row)
  }

  userIsAllowed(pid) {
    return !this._user.expired() && !pid.expired;
  }

  useremail() {
    return this._user.me()['email'];
  }

  reload() {
    //console.log("pid table reload");
    this.reloadHome.next('');
  }

  updateall = () => {
    this.doUpdateFilter('all');
  }



  printTransferPDF(id, pid) {
    //console.log("print transfer PDF", id, pid);
    this.printTransferPDFrequested = true;
    this._pidService.printTransferPDF(id, pid).subscribe(x => {
      //console.log("print transfer PDF init", x);
      this.putUrl = x['putUrl'];
      this.putToken = x['putToken'];
      this.transferPDFSpec = {
        id: id,
        pid: pid
      }
    });
  }

  completeTransferPDF() {
    console.log("complete print", this.putToken, this.transferPDFSpec);
    this._pidService.completeTransferPDF(this.transferPDFSpec['id'], this.transferPDFSpec['pid'], this.putToken).subscribe(x => {
      console.log("complete print ack", x);
    });
  }
}
